// F25 — Explanations content registry. Single source of truth for every
// explanation the app can show. Copy lives in the locales under `explain.*`;
// this file only wires IDs to surfaces, forms and illustrations.
//
// form: 'card' (inline, in page flow) | 'banner' (slim bar above a chart).
// A `deepDive` entry adds a "Learn more" action that opens ExplainModal.
// A `page` ref makes "Learn more" open the full-screen explainer instead
// (see EXPLAINER_PAGES below); deepDive then serves as unused fallback copy.

export const EXPLANATIONS = {
  'fire.what-is-fire': {
    surface: 'fire',
    form: 'card',
    icon: 'flame',
    titleKey: 'explain.fire.whatIsFire.title',
    bodyKey: 'explain.fire.whatIsFire.body',
    page: 'fire',
    deepDive: {
      bodyKey: 'explain.fire.whatIsFire.deep',
      illustration: 'fireCrossover',
    },
  },
  'fire.withdrawal-rate': {
    surface: 'fire',
    form: 'banner',
    icon: 'percent',
    titleKey: 'explain.fire.withdrawalRate.title',
    bodyKey: 'explain.fire.withdrawalRate.body',
    deepDive: {
      bodyKey: 'explain.fire.withdrawalRate.deep',
    },
  },
  'fire.fi-zone': {
    surface: 'fire',
    form: 'banner',
    icon: 'chart',
    titleKey: 'explain.fire.fiZone.title',
    bodyKey: 'explain.fire.fiZone.body',
  },
  'dashboard.projection-core': {
    surface: 'dashboard',
    form: 'banner',
    icon: 'sparkles',
    titleKey: 'explain.dashboard.projectionCore.title',
    bodyKey: 'explain.dashboard.projectionCore.body',
    deepDive: {
      bodyKey: 'explain.dashboard.projectionCore.deep',
      illustration: 'chartGrows',
    },
  },
  'simulation.monte-carlo': {
    surface: 'simulation',
    form: 'card',
    icon: 'dice',
    titleKey: 'explain.simulation.monteCarlo.title',
    bodyKey: 'explain.simulation.monteCarlo.body',
    page: 'simulation',
    deepDive: {
      bodyKey: 'explain.simulation.monteCarlo.deep',
      illustration: 'percentileFan',
    },
  },
  'simulation.percentiles': {
    surface: 'simulation',
    form: 'banner',
    icon: 'chart',
    titleKey: 'explain.simulation.percentiles.title',
    bodyKey: 'explain.simulation.percentiles.body',
  },
  'review.how-it-works': {
    surface: 'review',
    form: 'card',
    icon: 'review',
    titleKey: 'explain.review.howItWorks.title',
    bodyKey: 'explain.review.howItWorks.body',
    deepDive: {
      bodyKey: 'explain.review.howItWorks.deep',
      illustration: 'chartGrows',
    },
  },
  'timeline.scenarios': {
    surface: 'timeline',
    form: 'card',
    icon: 'calendar',
    titleKey: 'explain.timeline.scenarios.title',
    bodyKey: 'explain.timeline.scenarios.body',
    page: 'timeline',
    deepDive: {
      bodyKey: 'explain.timeline.scenarios.deep',
      illustration: 'timelineEvent',
    },
  },
};

export const getExplanation = (id) => EXPLANATIONS[id] || null;

// Full-screen feature explainers (onboarding-style, one animated screen per
// feature). Opened from explain cards ("Learn more"), the "How it works"
// header buttons, the snapshot modal, and the onboarding teaser step.
// Each feature's body is bespoke (see the per-feature components in
// ExplainPage.js); this registry only holds the shared shell data.
export const EXPLAINER_PAGES = {
  fire: {
    icon: 'flame',
    chip: 'chip-expense',
    nameKey: 'explain.pages.fire.name',
    titleKey: 'explain.pages.fire.title',
    subtitleKey: 'explain.pages.fire.subtitle',
  },
  timeline: {
    icon: 'calendar',
    chip: 'chip-estate',
    nameKey: 'explain.pages.timeline.name',
    titleKey: 'explain.pages.timeline.title',
    subtitleKey: 'explain.pages.timeline.subtitle',
  },
  simulation: {
    icon: 'dice',
    chip: 'chip-loan',
    nameKey: 'explain.pages.simulation.name',
    titleKey: 'explain.pages.simulation.title',
    subtitleKey: 'explain.pages.simulation.subtitle',
  },
  snapshots: {
    icon: 'camera',
    chip: 'chip-cash',
    nameKey: 'explain.pages.snapshots.name',
    titleKey: 'explain.pages.snapshots.title',
    subtitleKey: 'explain.pages.snapshots.subtitle',
  },
};

export const getExplainerPage = (id) => EXPLAINER_PAGES[id] || null;
